<template>
  <div class="application-page">
    <div class="container z-depth-3 white alarm-list-content">
        <h6 class="title">{{ $t('views.alarmlist.notifications') }}</h6>
        <div class="filter-content">
          <div class="title">{{ $t('views.alarmlist.filter') }}</div>
          <table class="filters">
            <tr>
              <td>{{ $t('views.alarmlist.severity') }}</td>
              <td>
                <label>
                  <input v-model="filter.warning" type="checkbox" checked="checked" />
                  <span class="checkbox-color">{{ $t('warning') }}</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.alarm" type="checkbox" checked="checked" />
                  <span>{{ $t('alarm') }}</span>
                </label>
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>{{ $t('views.alarmlist.typeofobject') }}</td>
              <td>
                <label>
                  <input v-model="filter.switch" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.switch') }} (MKW/PSI/SEVT)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.crossing" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.crossing') }} (OV)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.axlecounter" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.axlcounter') }} (AT)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.traindetection" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.traindetection') }} (TR)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.axleshunt" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.axleshunt') }} (SHUNT)</span>
                </label>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <label>
                  <input v-model="filter.railtemperature" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.railtemperature') }} (RT)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.location" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.location') }} (T/TI)</span>
                </label>
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </table>
        </div>

        <div>
          <a class="btn-flat right filter-menu" @click="toggleFilterMenu()">{{ $t('views.alarmlist.showcolumns') }}<i class="material-icons right">arrow_drop_down</i>
            <div v-show="filterMenu">
              <ul class="collection with-header">
                <li class="collection-item" v-on:click.stop="toggleColumnVisibility('date')">
                  <div>{{ $t('views.alarmlist.date') }}
                    <a href="#!" class="secondary-content">
                      <div class="switch">
                        <label>
                          <input type="checkbox" v-on:click.stop :checked="columns.date.visible">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </a>
                  </div>
                </li>
                <li class="collection-item" v-on:click.stop="toggleColumnVisibility('severity')">
                  <div>{{ $t('views.alarmlist.severity') }}
                    <a href="#!" class="secondary-content">
                      <div class="switch">
                        <label>
                          <input type="checkbox" v-on:click.stop :checked="columns.severity.visible">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </a>
                  </div>
                </li>
                <li class="collection-item" v-on:click.stop="toggleColumnVisibility('type')">
                  <div>{{ $t('views.alarmlist.typeofobject') }}
                    <a href="#!" class="secondary-content">
                      <div class="switch">
                        <label>
                          <input type="checkbox" v-on:click.stop :checked="columns.type.visible">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </a>
                  </div>
                </li>
                <li class="collection-item" v-on:click.stop="toggleColumnVisibility('path')">
                  <div>{{ $t('views.alarmlist.path') }}
                    <a href="#!" class="secondary-content">
                      <div class="switch">
                        <label>
                          <input type="checkbox" v-on:click.stop :checked="columns.path.visible">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </a>
        </div>
        <span class="filter-text" v-show="railObjectsInWarningOrError.length !== sortedAlarmList.length">{{railObjectsInWarningOrError.length - sortedAlarmList.length}} {{ $t('alarmlist.hiddenobjects') }}</span>
        <table class="alarm-list-table striped highlight">
          <thead>
            <tr class="clickable">
              <th  v-show="columns.date.visible" @click="toggleSort('date')">{{ $t('views.alarmlist.date') }}
                <i v-show="columns.date.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
                <i v-show="columns.date.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
              </th>
              <th v-show="columns.severity.visible" @click="toggleSort('severity')">{{ $t('views.alarmlist.severity') }}
                <i v-show="columns.severity.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
                <i v-show="columns.severity.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
              </th>
              <th v-show="columns.type.visible" @click="toggleSort('type')">{{ $t('views.alarmlist.typeofobject') }}
                <i v-show="columns.type.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
                <i v-show="columns.type.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
              </th>
              <th v-show="columns.path.visible" @click="toggleSort('path')">{{ $t('views.alarmlist.path') }}
                <i v-show="columns.path.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
                <i v-show="columns.path.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr class="clickable" v-for="railObject in sortedAlarmList.slice(listIndex*itemsPerPage, (listIndex*itemsPerPage)+itemsPerPage)" v-bind:key="railObject.RailObjectId" v-on:click="showDetail(railObject)">
              <td v-show="columns.date.visible" class="alarm-list-datetime">{{railObject.StatusMeasurementDateTime | formatDate}}</td>
              <td v-show="columns.severity.visible" class="alarm-list-status warning-text" v-if="railObject.MonitorStatusId === 2"><i class="material-icons">error</i></td>
              <td v-show="columns.severity.visible" class="alarm-list-status alarm-text" v-if="railObject.MonitorStatusId === 3"><i class="material-icons">warning</i></td>
              <td v-show="columns.type.visible" class="alarm-list-type">{{railObject.code}}</td>
              <td v-show="columns.path.visible" class="alarm-list-switch">{{railObject.path}}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="paging">
          <span class="buttons right">
            <a class="btn-flat" :disabled="listIndex === 0">
              <i class="material-icons" v-on:click="previousPage()">chevron_left</i>
            </a>
            <a class="btn-flat" :disabled="listIndex === parseInt(sortedAlarmList.length/itemsPerPage)">
              <i class="material-icons" v-on:click="nextPage()">chevron_right</i>
            </a>
          </span>

          <span class="page-number">
            <span class="right">{{sortedAlarmList.length}}</span>
            <span class="right">of</span>
            <span class="right">{{(listIndex*itemsPerPage)+1}}-{{Math.min(( listIndex*itemsPerPage)+itemsPerPage,sortedAlarmList.length)}}</span>
          </span>

          <span class="page-info right">
            <span>{{ $t('views.alarmlist.rowsperpage') }}: {{itemsPerPage}}</span>
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Router from '../../router/index'
import UtilitiesService from '../../services/UtilitiesService'
import RailObjectService from '../../services/RailObjectService'
import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import PossObjectCodeService from '../../services/PossObjectCodeService'

export default {
  name: 'alarmlist',
  data () {
    return {
      railObjectsInWarningOrError: [],
      listIndex: 0,
      itemsPerPage: 30,
      columns: {'date': {visible: true, sort: 'desc'}, 'severity': {visible: true, sort: null}, 'type': {visible: true, sort: null}, 'path': {visible: true, sort: null}},
      filterMenu: false,
      sortedAlarmList: [],
      filteredAlarmList: [],
      filter: {
        alarm: true,
        warning: true,
        switch: true,
        crossing: true,
        axlecounter: true,
        traindetection: true,
        axleshunt: true,
        mainvoltage: true,
        railtemperature: true,
        location: true
      }
    }
  },
  components: {
  },
  beforeCreate: function () {
  },
  created: function () {
    var possObjectCodesByDataSourceCodeAndObjectCodeDescription = {}
    var possObjectCodes = JSON.parse(JSON.stringify(PossObjectCodeService.getPossObjectCodes()))
    possObjectCodes.forEach((possObjectCode) => {
      possObjectCodesByDataSourceCodeAndObjectCodeDescription[possObjectCode.DataSourceCode + '-' + possObjectCode.ObjectDescription] = possObjectCode
    })

    var regionsById = {}
    var departmentsById = {}
    var complexesById = {}

    var regions = JSON.parse(JSON.stringify(RegionService.getRegions()))
    var departments = JSON.parse(JSON.stringify(DepartmentService.getDepartments()))
    var complexes = JSON.parse(JSON.stringify(ComplexService.getComplexes()))
    regions.forEach((region) => {
      regionsById[region.RegionId] = region
    })
    departments.forEach((department) => {
      departmentsById[department.DepartmentId] = department
    })
    complexes.forEach((complex) => {
      complexesById[complex.ComplexId] = complex
    })

    this.railObjectsInWarningOrError = []
    RailObjectService.getRailObjects().forEach((railObject) => {
      // console.log(railObject)
      if (railObject.StatusMeasurementDateTime) {
        railObject.StatusMeasurementDateTime = railObject.StatusMeasurementDateTime.substring(0, 19)
        railObject.timestamp = moment(String(railObject.StatusMeasurementDateTime), 'YYYY-MM-DDTHH:mm:ss').toDate().getTime()
        railObject.path = regionsById[railObject.RegionId].Name + ' \\ ' + departmentsById[railObject.DepartmentId].Name + ' \\ ' + complexesById[railObject.ComplexId].Name + ' \\ ' + railObject.Name
        railObject.code = possObjectCodesByDataSourceCodeAndObjectCodeDescription[railObject.DataSourceCode + '-' + railObject.ObjectCodeDescription].Code

        if (railObject.OperationModeId === 5) {
        } else {
          switch (railObject.MonitorStatusId) {
            case 1:
              break
            case 2:
              this.railObjectsInWarningOrError.push(railObject)
              break
            case 3:
              this.railObjectsInWarningOrError.push(railObject)
              break
            default:
              break
          }
        }
      }
    })
    this.filterList()
    this.sortList()
  },
  mounted: function () {
  },
  beforeDestroy: function () {
  },
  watch: {
    filter: {
      handler: function (newFilter) {
        this.filterList()
        this.sortList()
      },
      deep: true
    }
  },
  methods: {
    showDetail: function (railObject) {
      if (railObject.DataSourceCode === 'WID') {
        Router.push({
          name: 'SwitchMeasurement',
          params: {
            id: railObject.RailObjectId,
            measurementId: railObject.StatusMeasurementId
          },
          props: true
        })
      }
      if (railObject.DataSourceCode === 'ATD') {
        Router.push({
          name: 'AxleCounter',
          params: {
            railobjectid: railObject.RailObjectId
          }
        })
      }
      if (railObject.DataSourceCode === 'AKD') {
        Router.push({
          name: 'AxleShunt',
          params: {
            id: railObject.RailObjectId
          }
        })
      }
      if (railObject.DataSourceCode === 'CDD') {
        Router.push({
          name: 'MixedSignals',
          params: {
            railobjectid: railObject.RailObjectId
          },
          props: true
        })
      }
    },
    nextPage: function () {
      this.listIndex++
    },
    previousPage: function () {
      this.listIndex--
    },
    toggleColumnVisibility: function (name) {
      this.columns[name].visible = !this.columns[name].visible
    },
    toggleFilterMenu: function () {
      this.filterMenu = !this.filterMenu
    },
    toggleSort: function (name) {
      switch (name) {
        case 'date':
          this.columns.severity.sort = null
          this.columns.type.sort = null
          this.columns.path.sort = null
          break
        case 'severity':
          this.columns.date.sort = null
          this.columns.type.sort = null
          this.columns.path.sort = null
          break
        case 'type':
          this.columns.severity.sort = null
          this.columns.date.sort = null
          this.columns.path.sort = null
          break
        case 'path':
          this.columns.severity.sort = null
          this.columns.type.sort = null
          this.columns.date.sort = null
          break
      }

      if (this.columns[name].sort === 'asc') {
        this.columns[name].sort = 'desc'
      } else if (this.columns[name].sort === 'desc') {
        this.columns[name].sort = 'asc'
      } else {
        this.columns[name].sort = 'desc'
      }
      this.sortList()
    },
    filterList: function () {
      let filteredObjectType = (railObject) => {
        if (this.filter.switch && railObject.DataSourceCode === 'WID') {
          return true
        } else if (this.filter.crossing && railObject.DataSourceCode === 'OVD') {
          return true
        } else if (this.filter.axlecounter && railObject.DataSourceCode === 'ATD') {
          return true
        } else if (this.filter.traindetection && railObject.DataSourceCode === '???') {
          return true
        } else if (this.filter.axleshunt && railObject.DataSourceCode === 'AKD') {
          return true
        } else if (this.filter.mainvoltage && railObject.DataSourceCode === '???') {
          return true
        } else if (this.filter.railtemperature && railObject.DataSourceCode === 'RTD') {
          return true
        } else if (this.filter.location && railObject.DataSourceCode === 'CDD') {
          return true
        }
        return false
      }

      this.filteredAlarmList = []
      this.railObjectsInWarningOrError.forEach((railObject) => {
        if (filteredObjectType(railObject)) {
          if (this.filter.alarm && railObject.MonitorStatusId === 3) {
            this.filteredAlarmList.push(railObject)
          } else if (this.filter.warning && railObject.MonitorStatusId === 2) {
            this.filteredAlarmList.push(railObject)
          }
        }
      })

      this.listIndex = 0
    },
    sortList: function () {
      if (this.columns.date.sort === 'asc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'timestamp')
      } else if (this.columns.date.sort === 'desc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'timestamp').reverse()
      } else if (this.columns.severity.sort === 'asc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'MonitorStatusId')
      } else if (this.columns.severity.sort === 'desc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'MonitorStatusId').reverse()
      } else if (this.columns.type.sort === 'asc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'DataSourceCode')
      } else if (this.columns.type.sort === 'desc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'DataSourceCode').reverse()
      } else if (this.columns.path.sort === 'asc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'path')
      } else if (this.columns.path.sort === 'desc') {
        this.sortedAlarmList = UtilitiesService.sortByKey(this.filteredAlarmList, 'path').reverse()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alarm-list-content > .title {
  padding-top: 16px;
  padding-left: 22px;
}

.alarm-list-content .filter-content {
  position: relative;
  padding-left: 22px;
  padding-right: 22px;
  width: 100%;
}

.filter-content > .title {
  margin-top: 20px;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
}

.filters tr {
  border-bottom: none;
}

.filters td span {
  color: rgba(0, 0, 0, 0.87);
}

.filters td:first-child {
  color: rgba(0, 0, 0, 0.4);
}

.alarm-list-table {
  position: relative;
}

.alarm-list-table thead tr {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.alarm-list-table th, .alarm-list-table td {
  padding: 5px 5px;
  text-align: left;
}

.alarm-list-table .material-icons {
  font-size: 20px;
}

.paging {
  height: 50px;
  width: 100%;
  left: 0px;
  line-height: 50px;
  position: relative;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}

.paging .page-number {
  margin-right: 30px;
}

.paging .page-number span {
  padding-right: 5px;
}

.paging .page-info {
  margin-right: 40px;
}

.paging .buttons .btn-flat[disabled] {
  background-color: #fff !important;
}

.filter-menu {
  position: relative;
  z-index: 100;
}

.filter-menu > div {
  top: 28px;
  right: 10px;
  width: 250px;
  position: absolute;
}

.sort-arrow {
  position: absolute;
  margin-left: 5px;
}

.alarm-list-table th {
  white-space: nowrap;
}

.alarm-list-table th > i {
  position: relative;
}

.filter-text {
  margin-left: 22px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
}

.column-date {
  width:140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/alarmlist/AlarmList.vue